const ActionBar = {
  parts: ["root", "item"],
  baseStyle: {
    root: {
      display: "flex",
      alignItems: "center",
      borderRadius: "sm",
      paddingY: "sm",
      paddingX: "md",
      boxShadow: "md",
      columnGap: "md",
      backgroundColor: "text-primary"
    },
    item: {
      color: "background-primary",
      _hover: {
        backgroundColor: "lightBlueAlpha.300"
      },
      _dark: {
        _hover: {
          backgroundColor: "darkBlueAlpha.200"
        }
      }
    }
  }
};

export { ActionBar };
